/**
 * @file 辅助工具列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import IconTextCard from './IconTextCard';

import {IToolItem} from './IconTextCard';

interface IIconTextListProps {
    supportTools: IToolItem[];
}

const IconTextList: React.FC<IIconTextListProps> = props => {
    const {supportTools} = props;

    return (
        <div className="paddle-pp-icon-text-card-list">
            {supportTools.map((tool, index, thisArr) => (
                <IconTextCard
                    key={`${tool.title}${tool.text}${tool.icon}`}
                    {...tool}
                />
            ))}
        </div>
    );
};

export default IconTextList;
